import { BaseService } from './base'
import { APIPath } from 'utility/constant'

class PdfImageCompressionServiceClass {
    get(companyId) {
        return BaseService.get(APIPath.pdfImageCompressionSettings(companyId))
    }

    update(companyId, data) {
        return BaseService.put(
            APIPath.pdfImageCompressionSettings(companyId),
            data,
        )
    }

    reset(companyId) {
        return BaseService.post(
            APIPath.pdfImageCompressionSettingsReset(companyId),
            {},
        )
    }

    preview(companyId) {
        // Cache-bust so "Try another photo" always hits the server
        const url = `${APIPath.pdfImageCompressionSettingsPreview(
            companyId,
        )}?_=${Date.now()}`
        return BaseService.get(url)
    }
}

const PdfImageCompressionService = new PdfImageCompressionServiceClass()
Object.freeze(PdfImageCompressionService)
export { PdfImageCompressionService }
